'use client';
import React from 'react';
import { OrderDate as Shared } from '@launchstore/shared-puck';
import { useOrderData } from '@/lib/hooks/useOrderData';

const SharedRender = (Shared as any).render;

function OrderDateImpl(props: any) {
  const { order } = useOrderData();
  if (!order) return <SharedRender {...props} />;
  return <SharedRender {...props} date={order.created_at as any} />;
}

export const OrderDate: any = { ...Shared, render: (props: any) => <OrderDateImpl {...props} /> };
export default OrderDate;
